import { useEffect } from "react"
import qs from "qs"
import client from "../prismic-configuration"

const Preview = ({ history, location }) => {
  const linkResolver = (doc) => {
    if (doc.type === "news") {
      return `/stories/${doc.uid}${doc.lang !== "fi" ? `?lang=${doc.lang}` : ""}`
    } else if (doc.type === "page") {
      return `/${doc.uid}${doc.lang !== "fi" ? `?lang=${doc.lang}` : ""}`
    } else if (doc.type === "home") {
      return `/${doc.lang !== "fi" ? `?lang=${doc.lang}` : ""}`
    } else if (doc.type === "theme_page") {
      return `/themes/${doc.uid}${doc.lang !== "fi" ? `?lang=${doc.lang}` : ""}`
    } else if (doc.type === "stories") {
      return `/stories${doc.lang !== "fi" ? `?lang=${doc.lang}` : ""}`
    }
    return "/"
  }

  useEffect(() => {
    const { token, documentId } = qs.parse(location.search.slice(1))
    if (!token) {
      console.log("No token available, check your configuration")
    }
    try {
      client
        .getPreviewResolver(token, documentId)
        .resolve(linkResolver, "/")
        .then((url) => history.push(url))
    } catch (e) {
      console.log(e)
    }
  }, [history, location])

  return null
}

export default Preview
